import Vue from "vue";
import * as Sentry from "@sentry/vue";

const isDevelopment = location.href.includes('http://localhost')

Sentry.init({
  Vue,
  dsn: "https://dbe709061ad54790bf5bf3818aa189be@o4505251769155584.ingest.sentry.io/4505267589873664",
  // Performance Monitoring
  tracesSampleRate: isDevelopment ? 1.0 : 0.1, // Sentry recommends adjusting this value in production
  debug: isDevelopment ? true : false, // Enable debug mode
  environment: isDevelopment ? 'development' : 'production' // Set environment
});

export default Sentry